exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.carBrandContainer[data-v-5f294822] {                   \n    list-style: none;        \n    margin-left: -35px;\n    font-weight: 500;\n    font-size: 16px;        \n    padding-top: 10px;\n}\nli[data-v-5f294822] {\n    padding-top: 3px;\n}\n.panel-body-vue[data-v-5f294822] {\n    padding: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5f294822","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SideMenu/CarBrandSideBar.vue
// module id = 85
// module chunks = 0